import posthog from "posthog-js";
import { useTranslation } from "react-i18next";
import { HiOutlineClock } from "react-icons/hi2";

import Button from "@/components/atoms/Button";
import FeaturedText from "@/components/molecules/FeaturedText";

type Props = {
  featureName: string;
};

const ComingSoonFeaturedText = ({ featureName }: Props) => {
  const { t } = useTranslation();

  return (
    <FeaturedText
      featuredIcon={{ icon: HiOutlineClock, size: "xl" }}
      heading={t("company.detail.comingSoon.title")}
      body={t("company.detail.comingSoon.description")}
      className={"py-10"}
    >
      <div className={"mt-2"}>
        <Button
          label={t("featureRequest")}
          onClick={() => posthog.capture("feature_request", { feature: "company_detail", tab: featureName })}
          size="sm"
          variants={"secondary"}
        />
      </div>
    </FeaturedText>
  );
};

export default ComingSoonFeaturedText;
